<template>
</template>

<script>
export default {
	name: 'PageNotFound',
	components: {
	},
	data () {
		return {
		}
	},
	created: function ()
	{
		var self = this;
		self.$router.push({name: 'Homepage'});
	},
	methods: {
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

	@import "src/scss/toolkit";

</style>



// WEBPACK FOOTER //
// src/components/PageNotFound.vue